module.exports = __webpack_public_path__ + "static/media/car-visor.46368eef.svg";